import { render, staticRenderFns } from "./SystemSetting.vue?vue&type=template&id=64d5530d&"
import script from "./SystemSetting.vue?vue&type=script&lang=js&"
export * from "./SystemSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports